import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import contractTypesForSite from "../../../data/employee/contractTypesForSite";
import parseDropDownValue from "../../../controllers/utils/parseDropDownValue";
import employeeShiftTypes from "../../../data/employee/employeeShiftTypes";
import dayOfRestTypes from "../../../data/employee/dayOfRestTypes";
import Context from "../../../Context";

const Image = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 5px;
  object-fit: cover;
  margin-top: 5px;
  cursor: pointer;
  margin-left: 5px;
`;

let initialSelectedFields = [
  "Profile Nickname",
  "Site Codename",
  "Zone Name",
  "Profile First Name",
  "Profile Last Name",
  "Shift",
  "Site Place Name",
  "Profile Registration Number",
  "Employee Responsibility",
  "Day Of Rest",
];

export default function AssignmentHistoryTableForProfile({ items }) {
  const { t } = useTranslation();
  const { employeeFunctions } = useContext(Context);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Site</TableCell>
            <TableCell>Zone</TableCell>
            <TableCell>{t("dayOfRest")}</TableCell>
            <TableCell>Shift</TableCell>
            <TableCell>Fonction</TableCell>
            {/* <TableCell align="right">Start </TableCell> */}
            <TableCell>End </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row["Site Place Name"]}
              </TableCell>

              <TableCell>{row["Zone Name"]}</TableCell>
              <TableCell>
                {parseDropDownValue({
                  query: row["Day Of Rest"],
                  theArray: dayOfRestTypes,
                })}
              </TableCell>
              <TableCell>
                {parseDropDownValue({
                  query: row["Shift"],
                  theArray: employeeShiftTypes,
                })}
              </TableCell>
              <TableCell>
                {parseDropDownValue({
                  query: row["Employee Responsibility"],
                  theArray: employeeFunctions || contractTypesForSite,
                })}
              </TableCell>
              <TableCell>{formatDate(row["End Date"])}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  function formatDate(dateString) {
    const inputDate = new Date(dateString);
    const today = new Date();

    // Zero out time for comparison
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      return "EN COURS";
    }

    const day = inputDate.getUTCDate();
    const month = inputDate.toLocaleString("default", { month: "long" });
    const year = inputDate.getUTCFullYear();

    return `${day} ${month} ${year}`;
  }
}
